import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import type { FieldInitialSettings, FieldSchema, RawField } from '@FormModule';
import type { GenericField } from '@Types';
import { useForm } from '@FormModule';
import { useCartStore } from '@CartModule';

export default function () {
  const { getDetailsSchema } = useForm();
  const { donations } = storeToRefs(useCartStore());

  const fieldsSettings: FieldInitialSettings = {
    amount: {
      edit: {
        options: [],
      },
    },
    category: {
      edit: {
        options: [],
      },
    },
  };

  const rawFields: RawField[] = [
    {
      label: 'components.forms.labels.amount',
      name: 'amount',
      required: true,
      type: 'donation_amount',
      value: '',
    },
    {
      label: 'components.forms.labels.category',
      name: 'category',
      required: true,
      type: 'select',
      value: '',
    },
    {
      label: 'components.forms.labels.notes',
      name: 'notes',
      required: false,
      type: 'textarea',
      value: '',
    },
  ];

  const currentSchemaModels = ref<Set<GenericField>>(new Set());
  const fieldsSchema = ref<FieldSchema[]>([]);
  const formError = ref();
  const formId = ref('');
  const formName = ref('');
  const formType = ref('');

  function setForm(categories: any, donationsOptions: any) {
    if (fieldsSchema.value.length) return;

    if (fieldsSettings?.amount?.edit) fieldsSettings.amount.edit.options = donationsOptions;
    if (fieldsSettings?.category?.edit) fieldsSettings.category.edit.options = categories;

    fieldsSchema.value = getDetailsSchema(rawFields, fieldsSettings);

    if (donations.value.length) {
      fieldsSchema.value.forEach((field) => {
        let model = donations.value[0][field.name];

        if (field.name === 'amount') {
          const { _id, amount, description } = donations.value[0];
          model = { _id, amount, description };
        }

        field.value = model;
        field.model = model;
      });
    }
  }

  function resetFieldSchema() {
    currentSchemaModels.value = new Set();
    fieldsSchema.value = [];
    formError.value = null;
  }

  return {
    currentSchemaModels,
    fieldsSchema,
    formError,
    formId,
    formName,
    formType,
    setForm,
    resetFieldSchema,
  };
}
